import { RefObject, useLayoutEffect, useState } from "react";

type ElementSize = {
	width: number;
	height: number;
};

export default function useElementSize(ref: RefObject<HTMLElement | null>) {
	const [elementSize, setElementSize] = useState<ElementSize>({ width: 0, height: 0 });

	useLayoutEffect(() => {
		const element = ref.current;
		if (!element) return;

		const handleResize = () => setElementSize({ width: element.offsetWidth, height: element.offsetHeight });

		handleResize();
		const resizeObserver = new ResizeObserver(handleResize);
		resizeObserver.observe(element);
		return () => resizeObserver.disconnect();
	}, []);

	return elementSize;
}
